<template>
  <base-modal form title="New Role Pricing">
    <div class="columns">
      <div class="column">
        <radio-group
          v-if="availableRoles.length"
          type="inline"
          prompt-label="Select Role"
          :items="availableRoles"
          value-key="id"
          label-key="title"
          v-model="role"
          :error="errors.role_id"
          class="flex-grow is-marginless" />
        <notification v-else>All available roles already have pricing.</notification>
      </div>
    </div>
    <div slot="footer" class="buttons" v-if="availableRoles.length">
      <submit-button
        :disabled="loading"
        :working="working"
        @submit="save"
        class="is-success is-rounded">
        Save
      </submit-button>
    </div>
  </base-modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { newPrice } from '@/api/facility'
import differenceBy from 'lodash/differenceBy'

export default {

  props: {
    facilityId: Number,
  },

  data:() => ({
    working: false,
    loading: true,
    role: null,
  }),

  mounted() {
    this.listRoles().then(() => this.loading = false)
  },

  computed: {
    ...mapState('facility', ['facility']),
    ...mapState('role', ['roleList']),

    availableRoles() {
      return differenceBy(this.roleList, this.facility.roles, 'id')
    }
  },

  methods: {
    listRoles() {
      return this.$store.dispatch('role/list')
    },

    save() {
      this.working = true
      newPrice({
        facility: this.facilityId,
        role_id: this.role
      }, () => {
        this.$toast.success('Changes saved.')
        this.working = false
        this.$close(true)
      }, () => {
        this.working = false
      })
    }
  }

}
</script>
